module.exports = __webpack_public_path__ + "img/1602779109TAT_Group.90bf7f8d.svg";